













































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  days_of_week,
  today,
} from "@/config/dailySchedule/schedule-by-day.config.json";

import { splitString } from "@/services/strings";
import { size, type } from "@/config/files.config.json";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";

@Component({ components: { VuePdfEmbed } })
export default class DailyScheduleForm extends Vue {
  @Prop({ type: Boolean, default: true }) meny!: boolean;

  types = type.image.concat(type.pdf);
  daysWeek = days_of_week;
  day = today;
  text = "info";

  file: File | null = null;
  posterSRC = "";
  type = "";

  $refs!: {
    file: HTMLInputElement;
  };

  fileFormat(string: string | undefined): boolean {
    if (!string) return false;
    const split_arr = splitString(string, "/");
    return this.types.includes(split_arr[split_arr.length - 1]);
  }

  isUploading(): void {
    this.file = this.$refs.file.files ? this.$refs.file.files[0] : null;
    if (!this.file) {
      this.$bvModal.msgBoxConfirm(String(this.$i18n.t("error.empty")));
      return;
    }

    const type = this.file.type.split("/");
    this.type = type[type.length - 1];
    const fileSize = this.type == "pdf" ? size.pdf : size.image;
    if (!this.fileFormat(this.type) || this.file.size > fileSize) {
      this.text = "danger";
      this.file = null;
      return;
    } else this.text = "info";

    const blob = new Blob([this.file]);
    this.$emit("updateBlobFile", blob, this.day);
    this.posterSRC = URL.createObjectURL(blob);
  }

  renderPoster(): void {
    const canvas = document.getElementsByTagName("canvas");
    const canvasFull = document.createElement("canvas");
    document.body.append(canvasFull);
    canvasFull.id = "canvasFull";

    let width = 0;
    for (const slide of canvas) {
      if (width < slide.width) width = slide.width;
    }
    canvasFull.width = width;
    let height = 0;
    for (let i = 0; i < canvas.length - 1; i++) {
      height += canvas[i].height;
    }
    canvasFull.height = height;

    const ctx = canvasFull.getContext("2d");
    if (!ctx) return;

    // ctx.drawImage(s[0], 0, 0);
    // ctx.drawImage(s[1], 0, s[0].height);

    let drowHeight = 0;
    for (let i = 0; i < canvas.length - 1; i++) {
      ctx.drawImage(canvas[i], 0, drowHeight);
      drowHeight += canvas[i].height;
    }

    const imageDataUrl = canvasFull.toDataURL("img/jpg");

    const arr = imageDataUrl.split(",");
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file = new File([u8arr], "i.jpg", { type: "img/jpg" });
    const blob = new Blob([file]);
    this.$emit("updateBlobFile", blob, this.day);
    canvasFull.remove();
  }

  onReset(): void {
    this.day = today;
    this.text = "info";
    this.file = null;
    this.posterSRC = "";
    this.type = "";
  }
}
